import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {Table, Grid, Input, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {noTimeZoneFullISODate, reverseShortDate, dateFormatPicker} from '../../../common/constants/datesFormat';
import {ordersTrackingStatus} from '../../../common/dictionaries/classification';
import {PROCESSES} from '../../constants';

class Step extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'editing': false,
      'tentativeDate': moment(props.step.tentativeDate),
      'comment': props.step.observation,
    };
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleCommentChange = this.handleCommentChange.bind(this);
  }

  handleDateChange(value) {
    this.setState({'tentativeDate': value});
  }

  handleCommentChange(event, {value, name}) {
    this.setState({[name]: value});
  }

  handleEditClick() {
    this.setState({'editing': true});
  }

  handleCancelClick() {
    const {step} = this.props;

    this.setState({
      'editing': false,
      'tentativeDate': moment(step.tentativeDate),
      'comment': step.observation,
    });
  }

  handleSaveClick() {
    const {step} = this.props;
    const {tentativeDate, comment} = this.state;

    this.props.updateOrderTrackingStep(step.orderSequence, {
      'tentativeDate': moment(tentativeDate).format(noTimeZoneFullISODate),
      'processId': step.processId,
      'comment': comment,
    });
    this.setState({'editing': false});
  }

  renderTentativeDate() {
    const {editing, tentativeDate} = this.state;
    const {previousDate} = this.props;
    const dateRowWidth = this.props.isToyotaUser ? '12' : '16';

    if (!editing) {
      return (
        <React.Fragment>
          <Grid.Column width={dateRowWidth}>
            {moment(tentativeDate).format(reverseShortDate)}
          </Grid.Column>
          {this.renderEditIcon()}
        </React.Fragment>
      );
    }
    
    return (
      <React.Fragment>
        <Grid.Column width={dateRowWidth}>
          <DatePicker
            locale='es'
            customInput={<Input icon='calendar' size='mini' />}
            dateFormat={dateFormatPicker}
            minDate={previousDate ? moment(previousDate).toDate() : null}
            selected={moment(tentativeDate).toDate()}
            value={moment(tentativeDate).toDate()}
            onChange={this.handleDateChange}
          />
        </Grid.Column>
        {this.renderEditIcon()}
      </React.Fragment>
    );
  }

  renderComment() {
    const {editing, comment} = this.state;

    if (!editing) {
      return comment;
    }

    return (
      <Input fluid
        name='comment'
        maxLength='100'
        value={comment}
        onChange={this.handleCommentChange}
      />
    );
  }

  renderEditIcon() {
    const {isToyotaUser, step} = this.props;

    if (!isToyotaUser || !step.allowEdit) {
      return null;
    }

    if (this.state.editing) {
      return (
        <Grid.Column width='4'>
          <Icon link name='save' size='large' color='blue' onClick={this.handleSaveClick} />
          <Icon link name='close' size='large' color='red' onClick={this.handleCancelClick} />
        </Grid.Column>
      );
    }

    return (
      <Grid.Column width='4'>
        <Icon link name='write' size='large' color='blue' onClick={this.handleEditClick} />
      </Grid.Column>
    );
  }

  renderRealDate(value) {
    return value ? moment(value).format(reverseShortDate) : null;
  }

  render() {
    const {step} = this.props;
    const observationClass = step.status === 'R' ? 'comment delayed' : 'comment';

    return (
      <Table.Row>
        <Table.Cell>{PROCESSES[step.processId]}</Table.Cell>
        <Table.Cell>{this.renderRealDate(step.processDate)}</Table.Cell>
        <Table.Cell className='tentative-date'>
          <Grid>
            <Grid.Row verticalAlign='middle'>
              {this.renderTentativeDate(step.tentativeDate)}
            </Grid.Row>
          </Grid>
        </Table.Cell>
        <Table.Cell>{ordersTrackingStatus[step.status]}</Table.Cell>
        <Table.Cell className={observationClass}>{this.renderComment()}</Table.Cell>
      </Table.Row>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'isToyotaUser': state.session.isUserFromTDE,
  };
};

const {
  updateOrderTrackingStep,
} = Actions;

export default connect(mapStateToProps, {
  updateOrderTrackingStep,
})(Step);
